import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import Card from '../ui/Card';
import HelpItems from '../HelpItems/HelpItems';
import type { SettingsHubPanelProps } from '../../modules/configuration-settings/models';

const SettingsHubPanel: React.FC<SettingsHubPanelProps> = ({
  title,
  badge,
  description,
  helpItems,
  headerActions,
  children,
  footer,
  className,
  contentClassName,
}) => {
  const { colors } = useTheme();

  return (
    <Card variant="outlined" className={cn('overflow-hidden p-0', className)}>
      <div className={cn('relative border-b px-4 py-5 md:px-6 md:py-6', colors.border, colors.headerBg)}>
        <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div className="min-w-0 space-y-2">
            <div className="flex flex-wrap items-center gap-2">
              <h2 className={cn('text-lg font-semibold tracking-tight', colors.text)}>{title}</h2>
              {badge}
            </div>
            {description ? (
              <div className={cn('max-w-3xl text-sm leading-relaxed', colors.textMuted)}>{description}</div>
            ) : null}
            <HelpItems items={helpItems} />
          </div>
          {headerActions ? (
            <div className="flex shrink-0 items-center gap-1 self-start">{headerActions}</div>
          ) : null}
        </div>
      </div>
      <div className={cn('p-4 md:p-6', contentClassName)}>{children}</div>
      {footer ? <div className={cn('border-t px-4 py-4 md:px-6 md:py-4', colors.border)}>{footer}</div> : null}
    </Card>
  );
};

export default SettingsHubPanel;
